import { render } from "./PondList.vue?vue&type=template&id=35e07040&scoped=true&ts=true"
import script from "./PondList.vue?vue&type=script&lang=ts"
export * from "./PondList.vue?vue&type=script&lang=ts"

import "./PondList.vue?vue&type=style&index=0&id=35e07040&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e07040"]])

export default __exports__